import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NgDynamicBreadcrumbService } from 'ng-dynamic-breadcrumb';
import { CommonService } from 'src/app/_services/common.service';
import { MenuService } from 'src/app/_services/menu.service';

@Component({
  selector: 'app-page-intermediaire',
  templateUrl: './page-intermediaire.component.html',
  styleUrls: ['./page-intermediaire.component.scss']
})
export class PageIntermediaireComponent implements OnInit {

  rubrique: any;
  menu: any;
  children: any;
  constructor(private commonService: CommonService, private titleService: Title, private ngDynamicBreadcrumbService: NgDynamicBreadcrumbService,
    private route: ActivatedRoute, private menuService: MenuService) { }

  ngOnInit(): void {
    this.route.params.subscribe( params =>
      {
        this.rubrique = params["rubrique"];
        this.menu = params["menu"];
        this.getChildren();
      });
  }

  getChildren() {
    this.menuService.getChildren(this.rubrique).subscribe(data => {
      this.children = data[0]['items'];
      this.commonService.changeData("");
      this.titleService.setTitle(data[0].nom);
      this.ngDynamicBreadcrumbService.updateBreadcrumbLabels({customMenu: data[0].parent, customSection: data[0].nom});
    })
  }

}
